import ContactBookService from "@/services/contactBook.service";
import { useStore } from "vuex";
// import dayjs from "dayjs";
interface ContactBookState {
  loaded: boolean;
  categories: any[];
  userContactBookSize: number;
  groupContactBookSize: number;
  contacts: any[];
  groups: any[];
}

interface ChunkData {
  authenticated: boolean;
  data: {
    userContactBookSize: number;
    groupContactBookSize: number;
  };
}

const state = {
  loaded: false,
  userContactBookSize: 0,
  groupContactBookSize: 0,
  contacts: [],
  groups: [],
};

const getters = {
  getUserContactBookSize: (state: ContactBookState) => state.userContactBookSize,
  getGroupContactBookSize: (state: ContactBookState) => state.groupContactBookSize,
  getContacts: (state: ContactBookState) => state.contacts,
  getGroups: (state: ContactBookState) => state.groups,
  getContactBookLoaded: (state: ContactBookState) => state.loaded,
};

const actions = {
  loadChunkCount(context: any) {
    context.commit("LOAD_CHUNK_COUNT");
    return ContactBookService.loadChunkCount().then((response: any) => {
      const chunkData: ChunkData = response.data;
      context.commit("LOAD_CHUNK_COUNT_SUCCESS", chunkData);
    });
  },
  async loadContacts(context: any) {
    context.commit("LOAD_CONTACTS");
    for (let x = 0; x < state.userContactBookSize; x++) {
      const contacts = await ContactBookService.loadContacts(state.userContactBookSize);
      context.commit("LOAD_CONTACTS_SUCCESS", contacts.data);
    }
    context.commit("SORT_CONTACTS");
    context.dispatch("loadGroups");
  },
  loadGroups(context: any) {
    context.commit("LOAD_GROUPS");
    return ContactBookService.loadGroups(state.groupContactBookSize).then((response: any) => {
      context.commit("LOAD_GROUPS_SUCCESS", response.data);
    });
  },
};

const mutations = {
  LOAD_CHUNK_COUNT(state: ContactBookState) {
    state.userContactBookSize = 0;
    state.groupContactBookSize = 0;
  },
  LOAD_CHUNK_COUNT_SUCCESS(state: ContactBookState, chunkData: ChunkData) {
    state.userContactBookSize = chunkData.data.userContactBookSize;
    state.groupContactBookSize = chunkData.data.groupContactBookSize;
  },
  LOAD_CONTACTS(state: ContactBookState, contacts: any[]) {
    state.contacts = [];
    state.loaded = false;
  },
  LOAD_CONTACTS_SUCCESS(state: ContactBookState, object: any) {
    // let contacts: any[] = [];
    // for (let x = 0; x < 250; x++) {
    //   contacts = contacts.concat(object.data.contacts);
    // }
    const contacts = [...state.contacts, ...object.data.contacts];
    state.contacts = contacts;
  },
  SORT_CONTACTS(state: ContactBookState, contacts: any[]) {
    state.contacts = state.contacts.sort((a: any, b: any) => a.lastName.localeCompare(b.lastName));
  },
  LOAD_GROUPS(state: ContactBookState, contacts: any[]) {
    state.groups = [];
  },
  LOAD_GROUPS_SUCCESS(state: ContactBookState, data: any) {
    state.groups = data.data.groups;
    state.loaded = true;
  },
};

export const contactBook = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
